import { render, staticRenderFns } from "./ChooseGoodsCard.vue?vue&type=template&id=79761676&scoped=true"
import script from "./ChooseGoodsCard.vue?vue&type=script&lang=ts"
export * from "./ChooseGoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./ChooseGoodsCard.vue?vue&type=style&index=0&id=79761676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79761676",
  null
  
)

export default component.exports